export const ReceiptTypeEnum = {
  TRIP: 'trip',
  BOOKING: 'booking',
};
